import refs from '../refsLite'
import { updateDoc } from 'firebase/firestore/lite'

export async function setOrganizationPaymentTier(organizationId, paymentTier) {
  await updateDoc(refs.organization(organizationId, false), {
    paymentTier,
    updated: +new Date(),
  })
}
